import React from 'react';
import Typed from 'react-typed';
import './resume.css';
import {Container,Row, Col} from 'react-grid-system';



function Resume() {
    return (
        <div className="about55" id="resume">
           
                <h1 className="res">Experience</h1>
               
         
            
                <Container className="resumeShape">
                 
                    <Row>
                    <Col lg={6} id="summary" className="gridtextbox1">SUMMARY</Col>
                    <Col lg={6} className="gridtextbox2">
                    Customer Success and Account leader with proven ability to scale revenue and grow accounts. At Spoke, scaled customer accounts 200%+ and expanded portfolio from 4 to 19 accounts before promotion to Head of Accounts. Unique combination of CS expertise with hands-on technical fluency in React, UX/UI, and product development — enabling me to bridge customer needs, business goals, and technical reality. Seeking CS and Account Leadership roles where I can leverage this cross-functional depth to drive measurable outcomes.
                    <br/><br/><br/>
                    </Col>
                    </Row>
                    <Row>
                     <Col lg={6} id="experience" className="gridtextbox1">EXPERIENCE</Col>
                     <Col lg={6} className="gridtextbox2">

                     <div className="exp-title">Web Designer & Developer</div>
                     <div className="exp-company">All Seasons Landscaping · Contract</div>
                     <div className="dates">2024 – Present</div>
                     Following Spoke, the former CEO brought me into his next company's web project to lead a full React rebuild. Combined client discovery, stakeholder communication, UX strategy, and technical execution to deliver a complete platform from concept to deployment.
                     <br/><br/>

                     <div className="exp-title">Head of Accounts</div>
                     <div className="exp-company">Spoke, Inc. · Austin, TX (Hybrid)</div>
                     <div className="dates">Jul 2023 – May 2024</div>
                     Responsible for all Account Managers and customer accounts. Grew annual revenue by <strong>&gt;50%</strong> within 6 months of promotion. Established company-wide financial tracking process for individual customer accounts. Launched new talent office in Guadalajara, Mexico.
                     <br/><br/>

                     <div className="exp-title">Account Executive</div>
                     <div className="exp-company">Spoke, Inc. · Austin, TX (Hybrid)</div>
                     <div className="dates">Aug 2022 – Jul 2023</div>
                     Increased portfolio revenue by <strong>200%</strong> in under 9 months. Grew customer portfolio from 4 to 19 accounts in under 12 months. Built repeatable, high-conversion proposal process. Traveled to Philippines to establish key partnerships. Promoted to Head of Accounts less than one year after joining.
                     <br/><br/>

                     <div className="exp-title">Webmaster</div>
                     <div className="exp-company">Variety – The Children's Charity</div>
                     <div className="dates">Aug 2021 – Present</div>
                     Design and maintenance of official web presence. Leading ground-up redesign focused on increasing online donations.
                     <br/><br/>

                     <div className="exp-title">Maître D'</div>
                     <div className="exp-company">Innovative Dining Group (IDG)</div>
                     <div className="dates">Jun 2004 – Mar 2015</div>
                     Optimized customer flow to achieve daily revenue targets. Balanced demanding clientele with business objectives. Achieved industry-leading &gt;98% floor allocation.
                     <br/><br/><br/>

                    </Col>
                    </Row>
                    <Row>
                     <Col lg={6} id="education"className="gridtextbox1"> EDUCATION</Col>
                     <Col lg={6} className="gridtextbox2">THE GEORGE WASHINGTON UNIVERSITY, Washington, DC, USA Certificate in User Experience / User Interface Design <br></br><br></br>
                    
                        CODING DOJO, Tysons Corner, VA, USA Certificate in Software Development</Col>

                     </Row>
                     <div className="resLink">
                     <a href="https://docs.google.com/document/d/1InoCONYut-ZqAAz4LfDimWbaWS-vjIeLNeTK2_eBkHw/edit?usp=sharing" target="_blank" rel="noopener noreferrer" className="btn btn-dark">Full Resume</a>
                     </div>
                    
                    
                    
              

        </Container>
          
        </div>



    )
}

export default Resume